import { render, staticRenderFns } from "./DetailJiGou.vue?vue&type=template&id=4c9cd0f7"
import script from "./DetailJiGou.vue?vue&type=script&lang=js"
export * from "./DetailJiGou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports